var map = {
	"./lazyblock_cards.vue": "c9fa",
	"./lazyblock_contacts.vue": "27ed",
	"./lazyblock_container_cards.vue": "18fd",
	"./lazyblock_faq.vue": "36c7",
	"./lazyblock_last_posts.vue": "949a",
	"./lazyblock_newsletter.vue": "8dce",
	"./lazyblock_openingtime.vue": "4a6d",
	"./lazyblock_our_mission.vue": "dc0d",
	"./lazyblock_projects.vue": "d55a",
	"./lazyblock_qzr_events_list.vue": "3f74",
	"./lazyblock_rules.vue": "765f",
	"./lazyblock_school_panel.vue": "79b2",
	"./lazyblock_single_card.vue": "a080",
	"./lazyblock_slideshow_fullpage.vue": "5490",
	"./lazyblock_target_list.vue": "2ba6",
	"./lazyblock_this_month.vue": "a6f7",
	"./lazyblock_what_to_do.vue": "f5c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b51f";